import React, { useCallback, useEffect, useRef, useState } from 'react';

import { MODAL_WIDTHS } from '@/shared/lib/constants';
import { sortTags } from '@/shared/lib/sort';
import { BaseModal } from '@/shared/ui/BaseModal';
import { ExperimentTagInput } from '@/shared/ui/ExperimentTagInput';

import styles from './ExperimentTagsEditModal.module.css';

type ExperimentTagsEditModalProps = {
  open: boolean;
  tags: string[];
  onClose: () => void;
  onSubmit: (newTags: string[]) => void;
};

export const ExperimentTagsEditModal: React.FC<ExperimentTagsEditModalProps> = ({ open, tags, onClose, onSubmit }) => {
  const [editingTags, setEditingTags] = useState<string[]>([]);
  const [isTagsValid, setIsTagsValid] = useState(true);
  const prevOpenRef = useRef(false);

  useEffect(() => {
    if (open && !prevOpenRef.current) {
      const sortedTags = tags.length > 0 ? sortTags(tags) : [''];
      setEditingTags(sortedTags);
      setIsTagsValid(true);
    }
    prevOpenRef.current = open;
  }, [open, tags]);

  const handleSubmit = useCallback(() => {
    const filteredTags = editingTags.filter((tag) => tag.trim() !== '');
    onSubmit(filteredTags);
  }, [editingTags, onSubmit]);

  const hasChanges = () => {
    const currentTags = editingTags.filter((tag) => tag.trim() !== '').sort();
    const originalTags = [...tags].sort();

    if (currentTags.length !== originalTags.length) return true;
    return currentTags.some((tag, index) => tag !== originalTags[index]);
  };

  return (
    <BaseModal
      open={open}
      title="태그 수정"
      okText="저장"
      cancelText="취소"
      onOk={handleSubmit}
      onClose={onClose}
      okButtonProps={{ disabled: !hasChanges() || !isTagsValid }}
      width={MODAL_WIDTHS.STANDARD_FORM}
      centered>
      <div className={styles.content}>
        <ExperimentTagInput
          value={editingTags}
          onChange={setEditingTags}
          scrollable
          showAddButton
          onValidationChange={setIsTagsValid}
          errorText={!isTagsValid ? '이미 존재하는 태그입니다. 다른 태그를 입력해 주세요' : undefined}
        />
      </div>
    </BaseModal>
  );
};
